import DashboardIcon from "../../icons/DashboardIcon";
import RestuarantIcon from "../../icons/RestuarantIcon";
import RestuarantSettingIcon from "../../icons/RestaurantSetting";
import EmployeeIcon from "../../icons/EmployeeIcon";
import MenuIcon from "../../icons/MenuIcon";
import TableICon from "../../icons/TableIcon";
import RecentOrderIcon from "../../icons/RecentOrderIcon";
import WalletIcon from "../../icons/WalletIcon";
import EventIcon from "../../icons/EventIcon";
import GuideIcon from "../../icons/GuideIcon";
import { FEATURE_NAMES, SHOW_PROMOTIONS_PAGE } from "src/utils/isAllowedFeature";
import { SidebarRoutesEnum } from "src/enums/sidebarRoutes.enum";
import { restaurantSegment } from "src/utils/restaurantUrl";

/** (correlationId, restaurantName?) for building /restaurants/:segment/... */
const seg = (correlationId: string, name?: string) => restaurantSegment(correlationId, name);

export const ownerSidebar = [
  {
    url: "/my-restaurants",
    name: "My Restaurants",
    icon: RestuarantIcon,
  },
];

export const restaurantSidebar = [
  {
    url: (correlationId: string, name?: string) =>
      `/restaurants/${seg(correlationId, name)}/customers`,
    name: SidebarRoutesEnum.CUSTOMERS,
    icon: EmployeeIcon,
    isRoleBase: false,
  },
  {
    url: (correlationId: string, name?: string) => `/restaurants/${seg(correlationId, name)}/employee`,
    name: "Employees",
    icon: EmployeeIcon,
    isRoleBase: false,
  },
  {
    url: (correlationId: string, name?: string) => `/restaurants/${seg(correlationId, name)}/events`,
    name: SidebarRoutesEnum.EVENTS,
    isSubMenuOpen: false,
    icon: EventIcon,
    children: [],
    isRoleBase: true,
    roleName: FEATURE_NAMES.SpecialEventCreation,
  },
  {
    url: (correlationId: string, name?: string) => `/restaurants/${seg(correlationId, name)}/menu`,
    name: "Menu",
    isSubMenuOpen: false,
    icon: MenuIcon,
    children: [
      {
        name: "Categories",
        url: (correlationId: string, name?: string) => `/restaurants/${seg(correlationId, name)}/menu`,
        children: [],
      },
      {
        name: "Combos",
        url: (correlationId: string, name?: string) => `/restaurants/${seg(correlationId, name)}/combo`,
        children: [],
      },
      {
        name: SidebarRoutesEnum.MODIFIERS,
        url: (correlationId: string, name?: string) => `/restaurants/${seg(correlationId, name)}/modifier`,
        children: [],
      },
      {
        name: "Quick Service",
        url: (correlationId: string, name?: string) => `/restaurants/${seg(correlationId, name)}/quick-service`,
        children: [],
      },
    ],
    isRoleBase: true,
    roleName: FEATURE_NAMES.MenuCreationAndManagement,
  },
  {
    url: (correlationId: string, name?: string) =>
      `/restaurants/${seg(correlationId, name)}/orders`,
    name: "Orders",
    icon: RecentOrderIcon,
    isRoleBase: true,
    roleName: FEATURE_NAMES.PaymentProcessingThroughStripe,
  },
  {
    url: (correlationId: string, name?: string) =>
      `/restaurants/${seg(correlationId, name)}/finance/overview`,
    name: "Finance",
    isSubMenuOpen: false,
    icon: WalletIcon,
    children: [
      {
        name: "Overview",
        url: (correlationId: string, name?: string) =>
          `/restaurants/${seg(correlationId, name)}/finance/overview`,
        children: [],
      },
      {
        name: "Cash Drawer",
        url: (correlationId: string, name?: string) =>
          `/restaurants/${seg(correlationId, name)}/finance/cash-drawer`,
        children: [],
      },
      {
        name: "Disputes",
        url: (correlationId: string, name?: string) =>
          `/restaurants/${seg(correlationId, name)}/finance/disputes`,
        children: [],
      },
      {
        name: "Payments",
        url: (correlationId: string, name?: string) =>
          `/restaurants/${seg(correlationId, name)}/finance/payments`,
        children: [],
      },
      {
        name: "Payouts",
        url: (correlationId: string, name?: string) =>
          `/restaurants/${seg(correlationId, name)}/finance/payouts`,
        children: [],
      },
      {
        name: "PCI Compliance",
        url: (correlationId: string, name?: string) =>
          `/restaurants/${seg(correlationId, name)}/finance/pci-compliance`,
        children: [],
      },
      {
        name: "Payroll",
        url: (correlationId: string, name?: string) =>
          `/restaurants/${seg(correlationId, name)}/finance/payroll`,
        children: [],
      },
    ],
    isRoleBase: true,
    roleName: FEATURE_NAMES.PaymentProcessingThroughStripe,
  },
  {
    url: (correlationId: string, name?: string) =>
      `/restaurants/${seg(correlationId, name)}/promotions`,
    name: "Promotions",
    icon: EmployeeIcon,
    isRoleBase: true,
    roleName: FEATURE_NAMES.PromotionManagement,
  },
  {
    url: (correlationId: string, name?: string) =>
      `/restaurants/${seg(correlationId, name)}/restaurant-setting`,
    name: "Settings",
    icon: RestuarantSettingIcon,
    isRoleBase: false,
  },
  {
    url: (correlationId: string, name?: string) =>
      `/restaurants/${seg(correlationId, name)}/restaurant-table`,
    name: "Tables",
    icon: TableICon,
    isRoleBase: false,
  },
  {
    url: (correlationId: string, name?: string) =>
      `/restaurants/${seg(correlationId, name)}/reports/overview`,
    name: "Reports",
    isSubMenuOpen: false,
    icon: DashboardIcon,
    isRoleBase: true,
    roleName: FEATURE_NAMES.ReportingAndAnalytics,
    children: [
      {
        name: "Overview",
        url: (correlationId: string, name?: string) =>
          `/restaurants/${seg(correlationId, name)}/reports/overview`,
      },
      {
        name: "Sales",
        url: (correlationId: string, name?: string) =>
          `/restaurants/${seg(correlationId, name)}/reports/sales`,
      },
      {
        name: "Menu Performance",
        url: (correlationId: string, name?: string) =>
          `/restaurants/${seg(correlationId, name)}/reports/items`,
      },
      {
        name: "Payments",
        url: (correlationId: string, name?: string) =>
          `/restaurants/${seg(correlationId, name)}/reports/payments`,
      },
      {
        name: "Employees",
        url: (correlationId: string, name?: string) =>
          `/restaurants/${seg(correlationId, name)}/reports/employees`,
      },
      {
        name: "Tax",
        url: (correlationId: string, name?: string) =>
          `/restaurants/${seg(correlationId, name)}/reports/tax`,
      },
    ],
  },
  {
    url: (correlationId: string, name?: string) => `/restaurants/${seg(correlationId, name)}/guide`,
    name: "Operations guide",
    icon: GuideIcon,
    isRoleBase: false,
  },
].filter((item) => SHOW_PROMOTIONS_PAGE || item.name !== "Promotions");
